import { render, staticRenderFns } from "./centralizedPurchase.vue?vue&type=template&id=949b0b3e&scoped=true"
import script from "./centralizedPurchase.vue?vue&type=script&lang=js"
export * from "./centralizedPurchase.vue?vue&type=script&lang=js"
import style0 from "./centralizedPurchase.vue?vue&type=style&index=0&id=949b0b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949b0b3e",
  null
  
)

export default component.exports